<template>
  <div class="tarea-detalle">

    <!-- Título -->
    <div class="d-flex align-items-center mb-3">
      <font-awesome-icon :icon="['fas', 'list-check']" class="me-2 text-primary" />
      <h5 class="m-0">Detalles de la Tarea</h5>
    </div>

    <!-- Bloque 1: Planificación -->
    <div class="bloque-seccion">
      <h6 class="bloque-titulo">Planificación</h6>
      <div class="row">
        <div class="col-md-6">
          <label class="form-label">¿Es una Tarea Planificada?</label>
          <select class="form-select form-select-sm" v-model="localTipoDeTareaPlanificada">
            <option value="">Seleccione</option>
            <option v-for="tipo in localTiposDeTareasPlanificadas" :key="tipo.id" :value="tipo"
              :disabled="!tienePlan && !tipo.tipo.toLowerCase().includes('no planeada')">
              {{ tipo.tipo }}
            </option>
          </select>
          <div v-if="mostrarAdvertenciaSinTareas" class="alert alert-warning mt-2 small text-center">
            El evento <strong>{{ etapaEventoActual }}</strong> no tiene tareas planificadas. Seleccione <strong>No
              Planificada</strong>.
          </div>
        </div>

        <div class="col-md-6" v-if="mostrarTareasDelPlan">
          <label class="form-label">Tarea del Plan</label>
          <select class="form-select form-select-sm" v-model="localTareaPlanificadaSeleccionada" @change="emitirDatos">
            <option value="">Seleccione</option>
            <option v-for="tarea in localTareasDelPlan" :key="tarea.id" :value="tarea">
              [{{ tarea.numero_etapa }}] {{ tarea.etapa_evento_cultivo }} - {{ tarea.nombre_tarea }}
            </option>
          </select>
          <div v-if="etapaEventoActual" class="text-muted small mt-1">
            Etapa actual: <span class="badge bg-secondary">{{ etapaEventoActual }}</span>
          </div>
        </div>

        <div class="col-12 mt-2" v-if="localTareaPlanificadaSeleccionada && mostrarTareasDelPlan">
          <div class="bg-light border rounded p-2 small">
            <strong>Costo estimado:</strong> {{ localTareaPlanificadaSeleccionada.costo_estimado_usd }} $<br />
            <strong>Descripción:</strong> {{ localTareaPlanificadaSeleccionada.descripcion }}
          </div>
        </div>
      </div>
    </div>

    <!-- Bloque 2: Costos -->
    <div class="bloque-seccion">
      <h6 class="bloque-titulo">Costo y Duración</h6>
      <div class="row">
        <div class="col-md-6">
          <label class="form-label">Costo Final </label>
          <input type="number" step="0.01" class="form-control form-control-sm" v-model="localCostoFinal" @input="emitirDatos" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Duración (Horas)</label>
          <input type="number" step="0.01" class="form-control form-control-sm" v-model="localDuracion" @input="emitirDatos" />
        </div>
      </div>
    </div>

    <!-- Bloque 3: Categoría y Nombre -->
    <div class="bloque-seccion">
      <h6 class="bloque-titulo">Categoría y Nombre</h6>
      <div class="row">
        <div class="col-md-6">
          <label class="form-label">Categoría</label>
          <select class="form-select form-select-sm" v-model="localCategoriaId" @change="filtrarNombresTareas"
            :disabled="!localTipoDeTareaPlanificada">
            <option value="">Seleccione una categoría</option>
            <option v-for="categoria in categoriasTareas" :key="categoria.id" :value="categoria.id">
              {{ categoria.nombre }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="form-label">Nombre de Tarea</label>
          <select class="form-select form-select-sm" v-model="localNombreTarea" @change="filtrarAtributos"
            :disabled="!localTipoDeTareaPlanificada" required>
            <option value="">Seleccione un nombre</option>
            <option v-for="nombre in nombresTareasFiltrados" :key="nombre.id" :value="nombre.id">
              {{ nombre.nombre }}
            </option>
          </select>
          <div class="text-muted small mt-1">
            <i class="fas fa-info-circle me-1"></i>
            Si no encuentra una tarea que se ajuste a su necesidad, puede crearla en 
            <strong>Configuración → Administración de Variables</strong>
          </div>
        </div>
      </div>

      <div v-if="mensajeAdvertenciaTareaPlanificada" class="alert alert-warning small mt-2"
        v-html="mensajeAdvertenciaTareaPlanificada">
      </div>
    </div>

    <!-- Bloque 4: Atributos dinámicos -->
    <div class="bloque-seccion" v-if="localAtributosDeNombresTareas.length > 0">
      <h6 class="bloque-titulo">Datos Adicionales</h6>
      <div class="row">
        <div class="col-md-6" v-for="atributo in localAtributosDeNombresTareas" :key="atributo.id">
          <label :for="'atributo_' + atributo.id" class="form-label">{{ atributo.nombre }}</label>
          <input v-if="atributo.tipo_dato === 'Text'" type="text" class="form-control form-control-sm"
            v-model="localAtributos[atributo.id]" @input="emitirDatos" required/>
          <input v-else-if="atributo.tipo_dato === 'Integer'" type="number" class="form-control form-control-sm"
            v-model="localAtributos[atributo.id]" @input="emitirDatos" required />
          <input v-else-if="atributo.tipo_dato === 'Decimal'" type="number" class="form-control form-control-sm"
            v-model="localAtributos[atributo.id]" @input="emitirDatos" step="0.01" required/>
          <input v-else-if="atributo.tipo_dato === 'Date'" type="date" class="form-control form-control-sm"
            v-model="localAtributos[atributo.id]" @input="emitirDatos" required/>
        </div>
      </div>
    </div>

  </div>
</template>








<script>
import axios from '@/axios';

export default {
  props: {
    tiposDeTareasPlanificadas: {
      type: Array,
      default: () => [],
    },
    tareasDelPlan: {
      type: Array,
      default: () => [],
    },
    atributosDeNombresTareas: {
      type: Array,
      default: () => [],
    },
    selectedTareaPlanificada: {
      type: Object,
      default: null,
    },
    costoFinal: {
      type: Number,
      default: 0,
    },
    duracionHoras: {
      type: Number,
      default: 0,
    },
    esEdicion: {
      type: Boolean,
      default: false,
    },
    proyecto_id: {
      type: Number,
      required: true,
    },
    proyecto_evento_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      localTiposDeTareasPlanificadas: [], // Inicializamos como arreglo vacío
      localTipoDeTareaPlanificada: this.selectedTareaPlanificada ? this.selectedTareaPlanificada.tipo_planificacion_tarea : '',
      localTareaPlanificadaSeleccionada: this.selectedTareaPlanificada || null,
      localAtributosDeNombresTareas: [...this.atributosDeNombresTareas], // Hacemos una copia local
      localCostoFinal: this.costoFinal,
      localDuracion: this.duracionHoras,
      localAtributos: {},
      categoriasTareas: [],
      nombresTareasFiltrados: [],
      localCategoriaId: null,
      localNombreTarea: null,
      planDelProyecto: null,
      localTareasDelPlan: [...this.tareasDelPlan],
      clubActual: null,
      etapaEventoActual: null,
      mensajeAdvertenciaTareaPlanificada: '',

    };
  },
  created() {
    this.clubActual = this.$store.getters.getClubActual;
    // Cargamos los tipos de tareas planificadas si no están
    if (this.tiposDeTareasPlanificadas.length === 0) {
      this.obtenerTiposDeTareasPlanificadas();
    } else {
      this.localTiposDeTareasPlanificadas = [...this.tiposDeTareasPlanificadas];
    }

    // Cargamos las categorías de tareas
    this.cargarcategoriasTareas();

    //cargamos las tareas del plan
    this.cargarTareasDelPlan();
  },
  computed: {
    tienePlan() {

      return this.localTareasDelPlan.length > 0;
    },
    mostrarTareasDelPlan() {
      return this.localTipoDeTareaPlanificada && !this.localTipoDeTareaPlanificada.tipo.toLowerCase().includes('no planeada');
    },
    mostrarAdvertenciaSinTareas() {
      return this.localTareasDelPlan.length === 0 && this.etapaEventoActual;
    }


  },
  methods: {
    async obtenerTiposDeTareasPlanificadas() {
      try {
        const response = await axios.get('/api/categorias_tipos_de_tareas_planificadas');
        this.localTiposDeTareasPlanificadas = response.data;
      } catch (error) {
        console.error('Error al cargar los tipos de tareas planificadas:', error);
      }
    },
    async cargarcategoriasTareas() {
      try {
        const response = await axios.get('/api/categorias', { params: { club_id: this.clubActual.id } });
        this.categoriasTareas = response.data;

      } catch (error) {
        console.error('Error al cargar las categorías:', error);
      }
    },
    async cargarTareasDelPlan() {
      try {
        // 1. Obtener nombre del evento actual
        const nombreEventoRes = await axios.get(`/api/proyectoEventoGetNombreEvento/${this.proyecto_evento_id}`);
        const nombreEvento = nombreEventoRes?.data?.nombre_evento?.trim().toLowerCase();
        this.etapaEventoActual = nombreEvento;

        // 2. Obtener plan y filtrar tareas por etapa
        const { data } = await axios.get(`/api/proyecto/${this.proyecto_id}/obtener_plan/`);

        const tareasPlan = Array.isArray(data?.plan_cultivo_actividades) ? data.plan_cultivo_actividades : [];

        this.localTareasDelPlan = tareasPlan.filter(t =>
          t.etapa_evento_cultivo?.trim().toLowerCase() === nombreEvento.toLowerCase()
        );


        this.planDelProyecto = data || {};
      } catch (error) {
        console.error('Error al obtener tareas del plan o nombre del evento:', error);
        this.localTareasDelPlan = [];
        this.planDelProyecto = {};
      }
    },
    async filtrarNombresTareas() {
      this.mensajeAdvertenciaTareaPlanificada = '';
      this.localAtributosDeNombresTareas = [];
      this.localAtributos = {};

      const categoriaSeleccionada = this.categoriasTareas.find(c => c.id === this.localCategoriaId);
      const nombres = categoriaSeleccionada?.nombre_tareas || [];

      // Si hay tarea del plan seleccionada
      if (this.mostrarTareasDelPlan && this.localTareaPlanificadaSeleccionada?.nombre_tarea) {
        const nombreBuscado = this.localTareaPlanificadaSeleccionada.nombre_tarea;

        // Buscar en TODAS las categorías
        let encontrada = null;
        let categoriaQueLaContiene = null;

        for (const categoria of this.categoriasTareas) {
          for (const nombre of categoria.nombre_tareas || []) {
            if (nombre.nombre === nombreBuscado) {
              encontrada = nombre;
              categoriaQueLaContiene = categoria;
              break;
            }
          }
          if (encontrada) break;
        }

        if (encontrada) {
          // Si la categoría coincide con la seleccionada, mostrarla
          if (categoriaSeleccionada?.id === categoriaQueLaContiene?.id) {
            this.nombresTareasFiltrados = [encontrada];
            this.localNombreTarea = encontrada.id;
          } else {
            // La tarea existe, pero no en esta categoría
            this.nombresTareasFiltrados = [];
            this.localNombreTarea = '';
            this.mensajeAdvertenciaTareaPlanificada = `
⚠ La tarea del plan seleccionada <strong>${nombreBuscado}</strong> existe en la categoría <strong>${categoriaQueLaContiene.nombre}</strong>, pero no en la categoría seleccionada.<br>
Podés cambiar de categoría o seleccionar "No planificada" para continuar.
        `;
          }
        } else {
          // No se encontró en ninguna categoría
          this.nombresTareasFiltrados = [];
          this.localNombreTarea = '';
          this.mensajeAdvertenciaTareaPlanificada = `
⚠ La tarea del plan seleccionada <strong>${nombreBuscado}</strong> no se encuentra registrada en ninguna categoría.<br>
Podés marcarla como "No planificada" y continuar, o agregarla al plan más adelante.
      `;
        }
      } else {
        // Si no es una tarea planificada, solo cargamos los nombres de la categoría seleccionada
        this.nombresTareasFiltrados = nombres;
        this.localNombreTarea = '';
      }
    }
    ,

    async filtrarAtributos() {

      if (!this.localNombreTarea) {
        this.localAtributosDeNombresTareas = [];
        this.localAtributos = {};
        return;
      }

      const nombreTareaSeleccionado = this.nombresTareasFiltrados.find(n => n.id === this.localNombreTarea);
      this.localAtributosDeNombresTareas = nombreTareaSeleccionado ? nombreTareaSeleccionado.atributos : [];
      this.localAtributos = {};
    },
    emitirDatos() {
      // Emitir los datos al componente padre
      var plan_cultivo_actividades_id = null;
      var numero_etapa_plan_cultivo_actividades = null;
      var tipo_planificacion_tarea = null
      if (this.localTareaPlanificadaSeleccionada) {
        plan_cultivo_actividades_id = this.localTareaPlanificadaSeleccionada.id;
        numero_etapa_plan_cultivo_actividades = this.localTareaPlanificadaSeleccionada.numero_etapa;
      }

      if (this.localTipoDeTareaPlanificada) {
        tipo_planificacion_tarea = this.localTipoDeTareaPlanificada.tipo;
      }

      this.$emit('actualizar-detalles', {
        tipo_planificacion_tarea: tipo_planificacion_tarea,
        plan_cultivo_actividades_id: plan_cultivo_actividades_id,
        numero_etapa_plan_cultivo_actividades: numero_etapa_plan_cultivo_actividades,
        costo_final_usd: this.localCostoFinal,
        duracion_horas: this.localDuracion,
        atributos: this.localAtributos,
        categoria_id: this.localCategoriaId,
        nombre_tarea_id: this.localNombreTarea,
      });
    },
  },
  watch: {
    localTareaPlanificadaSeleccionada(newVal) {
      this.localCategoriaId = null;
      this.localNombreTarea = null;
      this.nombresTareasFiltrados = [];
      this.localAtributosDeNombresTareas = [];
      this.localAtributos = {};
      this.mensajeAdvertenciaTareaPlanificada = '';

      if (newVal) {
        const categoria = this.categoriasTareas.find(cat =>
          cat.nombre_tareas?.some(nt => nt.id === newVal.nombre_tarea_id)
        );

        if (categoria) {
          this.localCategoriaId = categoria.id;
          this.nombresTareasFiltrados = categoria.nombre_tareas.filter(nt => nt.id === newVal.nombre_tarea_id);
          this.mensajeAdvertenciaTareaPlanificada = '';

          this.localNombreTarea = null;

          // 🔄 Esperar a que localNombreTarea se reactive antes de buscar atributos
          this.$nextTick(() => {
            this.localNombreTarea = newVal.nombre_tarea_id;

            this.filtrarAtributos();
            this.emitirDatos();
          });
        } else {
          this.nombresTareasFiltrados = [];
          this.localAtributosDeNombresTareas = [];
          this.localAtributos = {};
        }
      }
    },
    localTipoDeTareaPlanificada(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.localCategoriaId = null;
        this.localNombreTarea = null;
        this.nombresTareasFiltrados = [];
        this.localAtributosDeNombresTareas = [];
        this.localAtributos = {};
        this.localTareaPlanificadaSeleccionada = null;

      }
    },
    localNombreTarea() {
     this.filtrarAtributos();
      this.emitirDatos();

    },
    selectedTareaPlanificada(newVal) {
      if (newVal) {
        this.localTipoDeTareaPlanificada = newVal.tipo_planificacion_tarea;
        this.localTareaPlanificadaSeleccionada = newVal;
      }
    },
    costoFinal(newVal) {
      this.localCostoFinal = newVal;
    },
    duracionHoras(newVal) {
      this.localDuracion = newVal;
    },
  },
};
</script>





<style scoped>
.section {
  border: 1px solid #e3e3e3;
  padding: 10px;
  /* Reducir padding */
  border-radius: 8px;
  margin-bottom: 15px;
  /* Reducir margen inferior */
  background-color: #f9f9f9;
  /* Fondo claro para resaltar */
}

.section-title {
  margin-bottom: 10px;
  /* Reducir espacio debajo del título */
  font-size: 1.1rem;
  /* Reducir tamaño del título */
  color: var(--app-primary);
  font-weight: 600;
}

.form-label {
  margin-bottom: 0.2rem;
  /* Reducir margen debajo de las etiquetas */
}

.form-control-sm,
.form-select-sm {
  padding: 0.25rem 0.5rem;
  /* Reducir el tamaño del campo de entrada */
  font-size: 0.9rem;
  /* Reducir el tamaño del texto del input */
}

.details-list {
  list-style-type: none;
  padding-left: 0;
}

.details-list li {
  margin-bottom: 0.2rem;
}

.tarea-detalle {
  background: #fdfdfd;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e2e2e2;
}

.bloque-seccion {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #ccc;
}

.bloque-titulo {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 10px;
  color: #555;
}

.form-label {
  font-size: 0.85rem;
  margin-bottom: 0.2rem;
}

select.form-select-sm,
input.form-control-sm {
  font-size: 0.85rem;
}
</style>